import React from "react";
import { Navigate, useParams } from "react-router-dom";

const ArticleEditorPage = () => {
  const { articleId } = useParams();
  const params = new URLSearchParams({ tab: "editor" });
  if (articleId) {
    params.set("articleId", articleId);
  }
  return <Navigate to={`/gestione-contenuti/magazine?${params.toString()}`} replace />;
};

export default ArticleEditorPage;
